<template>
    <div class="subPage center">
        <div class="nomal_box">
            <!-- 用户信息 -->
            <Information :userInfo="userInfo" :menuTypes="menuTypes" />
            <!-- 余额 -->
            <Property :menuTypes="menuTypes" :ownRank="ownRank" :userInfo="userInfo" :idolInfo="idolInfo" :property="property" />
            <!-- 排名 -->

            <!--{{idolInfo}}-->
            <!-- <Rank :rank="userInfo.memberNo" :rankText="menuTypes.rank" :ownRank="ownRank"/>-->
        </div>
        <!-- 我的战绩 -->
        <Profit :profit="profit" :menuTypes="menuTypes" />
        <!-- 我的积分 -->

        <!-- <Score :score="score" :menuTypes="menuTypes"/> -->
        <!-- 我的会员 -->

        <Member :nexus="nexus" :menuTypes="menuTypes" />
        <!-- 渠道信息 -->

        <Channel :menuTypes="menuTypes" :channel="channel" :initChannel="initChannel" />
        <router-view></router-view>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Score from '../userElement/Score';
import Property from '../userElement/Property';
import Rank from '../userElement/Rank';
import Information from '../userElement/Information';
import Profit from '../userElement/Profit';
import Member from '../userElement/Member';
import Channel from '../userElement/Channel';
import { getQueryString } from '../../utils/utils';

export default {
  watch: {
    channel: function() {
      this.initChannel = true;
    },
    /*       token: function(val) {
            if (val) this.$store.dispatch('user/init')
        },*/
  },
  name: 'User',
  meta:{page:true},
  data() {
    return {
      initChannel: false,
    };
  },
  computed: {
    ...mapGetters('userinterface', {
      menuTypes: 'getMenuType',
    }),
    ...mapGetters('user', {
      userInfo: 'getUserInfo',
      idolInfo: 'getIdolInfo',
      property: 'getProperty',
      score: 'getScore',
      profit: 'getProfit',
      nexus: 'getNexus',
      channel: 'getChannel',
      ownRank: 'getOwnRank',
    }),
  },
  components: {
    Score,
    Property,
    Rank,
    Information,
    Profit,
    Member,
    Channel,
  },
  created() {
    this.$store.dispatch('user/init');

    //this.$store.dispatch('user/getUserInfo');

    // this.getQueryString = getQueryString;
    // this.userId = this.getQueryString('userId');
    //this.$store.dispatch('user/getToken');
    // const path = this.$router.history.current.path;
    // this.$store.dispatch('userinterface/changeSelectTab', { selectVal: path, userId: this.userId} );
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.subPage {
  padding-bottom: 0.16rem;
}
.nomal_box {
  height: calc(2rem - 0.24rem);
  padding-top: 0.24rem;
  width: auto;
}
.data-table {
  height: 2.23rem;
  width: 3.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/page/User.vue